module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "l-footer"
  }, [_c('div', {
    staticClass: "l-footer__primary"
  }, [_c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/contact-us"
    }
  }, [_vm._v("Customer Service")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/contact-us"
    }
  }, [_vm._v("Sales Representatives")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/contact-us"
    }
  }, [_vm._v("Showrooms")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Downloads")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Color-Guide"
    }
  }, [_vm._v("Color Guide")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Price-Lists"
    }
  }, [_vm._v("Price Lists")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Catalogs"
    }
  }, [_vm._v("Catalogs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Product-Cut-Sheets"
    }
  }, [_vm._v("Product Cut Sheets")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Environmental"
    }
  }, [_vm._v("Environmental")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Installation-Assembly"
    }
  }, [_vm._v("Installation + Assembly")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/downloads#Maintenance-Cleaning"
    }
  }, [_vm._v("Maintenance + Cleaning")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Product")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/by-the-yard"
    }
  }, [_vm._v("By the Yard")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/acoustic"
    }
  }, [_vm._v("Acoustic")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/drapery"
    }
  }, [_vm._v("Drapery")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/floor-coverings"
    }
  }, [_vm._v("Floor Coverings")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/hanging-panels"
    }
  }, [_vm._v("Hanging Panels")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/modular"
    }
  }, [_vm._v("Modular")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/shop/product/hanging-panel-track-system"
    }
  }, [_vm._v("Track System")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/wall-panels"
    }
  }, [_vm._v("Wall Panels")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Custom")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/about-custom"
    }
  }, [_vm._v("About Custom")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/category/custom"
    }
  }, [_vm._v("Custom Cut Design Felt")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/shop/product/custom-floor-coverings"
    }
  }, [_vm._v("Floor Coverings")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/shop/product/custom-hanging-panels"
    }
  }, [_vm._v("Hanging Panels")])]), _vm._v(" "), _c('nav', {
    staticClass: "footer-link-list"
  }, [_c('h1', {
    staticClass: "footer-link-list-heading"
  }, [_vm._v("Policies")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/faq"
    }
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/selling-policy"
    }
  }, [_vm._v("Selling Policy")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.filzfelt.com/terms-of-use"
    }
  }, [_vm._v("Terms Of Use")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-footer__secondary"
  }, [_c('form', {
    staticClass: "mailing-list-form validate",
    attrs: {
      "action": "https://filzfelt.us6.list-manage.com/subscribe/post?u=b7c765aef80b20793da90832f&id=1f09615de6",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('input', {
    staticClass: "input-text mailing-list-form__input required email",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "Enter your email address..."
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mailing-list-form__submit button",
    attrs: {
      "type": "submit",
      "value": "Sign Up",
      "name": "subscribe",
      "id": "mc-embedded-subscribe"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "social-links"
  }, [_c('h2', {
    staticClass: "social-links__heading"
  }, [_vm._v("Follow Us")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--facebook",
    attrs: {
      "href": "https://www.facebook.com/filzfelt",
      "target": "_blank"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--instagram",
    attrs: {
      "href": "https://instagram.com/filzfelt/",
      "target": "_blank"
    }
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('a', {
    staticClass: "social-links__link social-links__link--vimeo",
    attrs: {
      "href": "https://vimeo.com/filzfelt",
      "target": "_blank"
    }
  }, [_vm._v("Vimeo")])]), _vm._v(" "), _c('div', {
    staticClass: "social-links"
  }, [_c('h2', {
    staticClass: "social-links__heading"
  }, [_vm._v("LOOKING FOR LEATHER?")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.spinneybeck.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "//www.filzfelt.com/images/pages/footer/spinneybeck.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-info"
  }, [_c('div', {
    staticClass: "vcard"
  }, [_c('div', {
    staticClass: "tel"
  }, [_vm._v("800.482.7777")]), _vm._v(" "), _c('div', {
    staticClass: "tel"
  }, [_vm._v("+1.716.446.2380")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@filzfelt.com"
    }
  }, [_vm._v("info@filzfelt.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "contact-info__copyright"
  }, [_vm._v("©2017 FilzFelt. All Rights Reserved.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e30800c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/wrappers/FooterFilzfelt.vue
// module id = 565
// module chunks = 1